export class AzureEntraIdPolicyConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "users",
            "baseName": "users",
            "type": "EntraIdEntitySelection",
            "format": ""
        },
        {
            "name": "groups",
            "baseName": "groups",
            "type": "EntraIdEntitySelection",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureEntraIdPolicyConfig.attributeTypeMap;
    }
    constructor() {
    }
}
